<script>
import {SURFACES, buildPayload} from '@/components/filters/capabilities'
import FilterBar from "@/components/filters/FilterBar.vue";
import axios from "axios";
import PhotoCardV2 from "@/components/photos/PhotoCardV2.vue";
import {mapMutations} from "vuex";
export default {
  name: "QueryPhotos",
  components: {PhotoCardV2, FilterBar,},
  data() {
    return {
      photo_recs: [],
      total_photo_ct: 0,
      num_pages: 0,
      curr_page: 1,
      categories: [],
      selectedItems: [],
      fromDateVal: '',
      toDateVal: '',
      photoFilter: {
        fromDt: null,
        thruDt: null,
        tags: [],
        projects: [],
        jobs: [],
        taggers: [],
        respIdSearchFreeForm: null,
        onlyNeedsReview: false,
        showQCed: false,
        includeInactive: false,
        country: null,
        retailer: null,
        department: null,
      },
      isLoading: false,
    }
  },
  watch: {
    "curr_page": function (newPage) {
      this.handlePageChange(newPage)
    }
  },
  methods: {
    ...mapMutations(['setMessage']),
    setPhotoFilters(filters) {
      this.photoFilter = filters
      this.getPhotos()
    },
    handlePageChange(page) {
      this.curr_page = page
      this.getPhotos()
    },
    getPhotos: function () {
      let self = this
      this.photo_recs = []
      this.total_photo_ct = 0
      this.num_pages = 0


      // if no photo filters defined then message the user to set filters
      if (this.photoFilter.fromDt === null && this.photoFilter.thruDt === null && this.photoFilter.tags.length === 0 && this.photoFilter.projects.length === 0 && this.photoFilter.jobs.length === 0 && this.photoFilter.taggers.length === 0 && this.photoFilter.respIdSearchFreeForm === null && this.photoFilter.onlyNeedsReview === false && this.photoFilter.showQCed === false && this.photoFilter.country === null && this.photoFilter.retailer === null && this.photoFilter.department === null) {
        this.setMessage({text: 'Please set filters to query photos', type: 'warning', alert: true})
        return
      }

      self.isLoading = true
      // IT-707 P2.1: key names and coercion come from the shared capability
      // builder; this view keeps its own transport and response handling.
      let payload = buildPayload(SURFACES.PHOTO_QC, this.photoFilter)
      payload.page = this.curr_page

      return axios.post('/api/photos/photo_query/', payload)
          .then(response => {
            self.isLoading = false
            this.photo_recs = response.data.photo_recs
            this.total_photo_ct = response.data.total_photo_ct
            this.num_pages = response.data.num_pages
          })
          .catch(error => {
            self.isLoading = false
            console.log(error)
          })
    },
  },
}
</script>

<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <FilterBar surface="photoQc" :initial-filter="photoFilter" @apply-filters="setPhotoFilters($event)"></FilterBar>
      </v-col>
    </v-row>
    <v-divider> </v-divider>
    <v-progress-circular v-if="isLoading" indeterminate></v-progress-circular>
    <v-row>
      <v-col>
        Total Photos: <b>{{ total_photo_ct }}</b> <i>(5,000 photo limit)</i>
      </v-col>
    </v-row>

    <div fluid>
      <v-row>
        <v-col
            v-for="image in photo_recs"
            :key="image.id"
            :lg="6"
            :md="6"
            :sm="12"
            :xl="4"
            :xs="12"
        >
          <photo-card-v2 :editable="true" :image="image" >
          </photo-card-v2>

        </v-col>
      </v-row>
    </div>
    <v-spacer></v-spacer>
    <v-divider class="mt-5"> </v-divider>
    <v-pagination class="ma-3" v-model="curr_page" :length="num_pages"></v-pagination>
  </v-container>
</template>

<style scoped>

</style>